// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var RelayEnv = require("../../../RelayEnv.bs.js");
var DebounceP = require("../../common/DebounceP.bs.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ReasonPromise = require("../../ReasonPromise.bs.js");
var AutocompleteV5 = require("../../../v5/autocomplete/AutocompleteV5.bs.js");
var Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var SelectInputTextSize = require("../../../v5/common/Form/SelectInputTextSize.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var NotificationPreferencesAreasInputV5Query_graphql = require("../../../__generated__/NotificationPreferencesAreasInputV5Query_graphql.bs.js");
var NotificationPreferencesAreasInputV5_result_graphql = require("../../../__generated__/NotificationPreferencesAreasInputV5_result_graphql.bs.js");

var getConnectionNodes = NotificationPreferencesAreasInputV5_result_graphql.Utils.getConnectionNodes;

var areaTypeV5_decode = NotificationPreferencesAreasInputV5_result_graphql.Utils.areaTypeV5_decode;

var convertFragment = NotificationPreferencesAreasInputV5_result_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationPreferencesAreasInputV5_result_graphql.node, convertFragment, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(NotificationPreferencesAreasInputV5_result_graphql.node, convertFragment, fRef);
}

var Fragment_areaTypeV5_fromString = NotificationPreferencesAreasInputV5_result_graphql.Utils.areaTypeV5_fromString;

var Fragment = {
  getConnectionNodes: getConnectionNodes,
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: Fragment_areaTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  readInline: readInline
};

var convertVariables = NotificationPreferencesAreasInputV5Query_graphql.Internal.convertVariables;

var convertResponse = NotificationPreferencesAreasInputV5Query_graphql.Internal.convertResponse;

var convertWrapRawResponse = NotificationPreferencesAreasInputV5Query_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, NotificationPreferencesAreasInputV5Query_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, NotificationPreferencesAreasInputV5Query_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(NotificationPreferencesAreasInputV5Query_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(NotificationPreferencesAreasInputV5Query_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(NotificationPreferencesAreasInputV5Query_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(NotificationPreferencesAreasInputV5Query_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function getOptionValue(param) {
  return param.id;
}

function getOptionLabel(param) {
  return param.label;
}

var Area = {
  getOptionValue: getOptionValue,
  getOptionLabel: getOptionLabel
};

function trimInput(s) {
  return (function (__x) {
                return __x.replace(/\s+/g, " ");
              })((function (__x) {
                    return __x.replace(/[^\w\s]/g, " ");
                  })(s)).trim();
}

function queryFn(searchTerm) {
  return ReasonPromise.map(Utils__Promise.fromJsPromise(fetchPromised(RelayEnv.environment, {
                      searchTerm: searchTerm
                    }, undefined, undefined)), (function (v) {
                if (v.TAG !== "Ok") {
                  return {
                          TAG: "Error",
                          _0: {
                            NAME: "REJECTED",
                            VAL: v._0
                          }
                        };
                }
                var r = v._0.notificationPreferenceAreasAutocomplete;
                if (r === undefined) {
                  return {
                          TAG: "Error",
                          _0: "EMPTY_RESULT"
                        };
                }
                var response = readInline(r.fragmentRefs);
                var areas = getConnectionNodes(response.areas);
                return {
                        TAG: "Ok",
                        _0: Core__Array.filterMap(areas, (function (param) {
                                var label = param.label;
                                var id = param.id;
                                return Core__Option.map(Core__Option.flatMap(param.type_, (function (v) {
                                                  return areaTypeV5_decode(v);
                                                })), (function (t) {
                                              return {
                                                      id: id,
                                                      label: label,
                                                      type_: t
                                                    };
                                            }));
                              }))
                      };
              }));
}

function NotificationPreferencesAreasInputV5(props) {
  var excludeItemFn = props.excludeItemFn;
  var status = props.status;
  var onChange = props.onChange;
  var queryFn$1 = DebounceP.make(300, (function (input) {
          return Utils__Promise.toJsPromise(queryFn(input));
        }));
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(AutocompleteV5.AsyncSelect.Single.make, {
                    getOptionLabel: getOptionLabel,
                    getOptionValue: getOptionValue,
                    isClearable: true,
                    loadOptions: (function (v) {
                        var v$1 = trimInput(v);
                        if (v$1.length < 2) {
                          return Promise.resolve([]);
                        } else {
                          return queryFn$1(trimInput(v$1)).then(function (res) {
                                      if (excludeItemFn !== undefined) {
                                        return res.filter(function (area) {
                                                    return excludeItemFn(area);
                                                  });
                                      } else {
                                        return res;
                                      }
                                    });
                        }
                      }),
                    onBlur: props.onBlur,
                    onFocus: props.onFocus,
                    onChange: (function (value) {
                        if (onChange !== undefined) {
                          return onChange(value);
                        }
                        
                      }),
                    noOptionsMessage: (function (v) {
                        return v.length < 2 ? "Type at least two characters" : "No areas match \"" + v + "\"";
                      }),
                    placeholder: "Add a county, city, neighborhood, or ZIP",
                    status: status !== undefined ? (
                        status === "ok" ? "Success" : "Failure"
                      ) : "Neutral"
                  }),
              className: SelectInputTextSize.className
            });
}

var make = NotificationPreferencesAreasInputV5;

exports.Fragment = Fragment;
exports.Query = Query;
exports.Area = Area;
exports.trimInput = trimInput;
exports.queryFn = queryFn;
exports.make = make;
/* use Not a pure module */
